import { Fragment, useEffect, useState } from 'react';
import { Container } from '@/components/container';
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle
} from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { OffersContent } from './OffersContent';
import { NoOffersContent } from './NoOffersContent';
import { KeenIcon } from '@/components';
import axios from 'axios';
import { OfferDetailsData } from '@/pages/hettwer/types/OfferDetailsData';
import { useParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { OfferModal } from '@/pages/hettwer/offer/blocks/source/OfferModal.tsx';

const OffersPage = () => {
  const [offers, setOffers] = useState<OfferDetailsData[]>([]);
  const [offerModalOpen, setOfferModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const { tab } = useParams<{ tab?: string }>();
  const [activePage] = useState<string>(tab || 'overview'); // kept if needed later

  const API_OFFERS = `${import.meta.env.VITE_APP_API_URL}/offers`;
  const API_OFFER = `${import.meta.env.VITE_APP_API_URL}/offer`;

  const openModal = () => setOfferModalOpen(true);
  const closeModal = () => setOfferModalOpen(false);

  const fetchOfferData = async () => {
    setLoading(true);
    try {
      const response = await axios.get<OfferDetailsData[]>(API_OFFERS, {
        headers: { Accept: 'application/json' }
      });

      setOffers(response.data);

      if (response.data.length === 0) {
        openModal();
      }
    } catch (err) {
      enqueueSnackbar(`Angebote konnten nicht geladen werden: ${err}`, {
        variant: 'solid',
        state: 'danger'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDeleteOffer = async (offerId: string) => {
    try {
      await axios.delete(`${API_OFFER}/${offerId}`, {
        headers: { 'Content-Type': 'application/json' }
      });

      enqueueSnackbar('Das Angebot wurde erfolgreich gelöscht.', {
        variant: 'solid',
        state: 'success'
      });

      fetchOfferData();
    } catch (err) {
      enqueueSnackbar(`Angebot konnte nicht gelöscht werden: ${err}`, {
        variant: 'solid',
        state: 'danger'
      });
    }
  };

  useEffect(() => {
    fetchOfferData();
  }, []);

  return (
    <Fragment>
      <PageNavbar />

      <Container>
        <Toolbar>
          <ToolbarHeading>
            <ToolbarPageTitle />
            <ToolbarDescription>
              Alle Angebote anzeigen und verwalten, um Projekte strukturiert zu organisieren und die
              Zuordnung zu konkreten Anforderungen zu vereinfachen.
            </ToolbarDescription>
          </ToolbarHeading>

          <ToolbarActions>
            <button
              type="button"
              onClick={openModal}
              className={`btn btn-sm btn-primary ${offers.length === 0 ? 'pulsating' : ''}`}
            >
              <KeenIcon icon="plus" /> Neues Angebot anlegen
            </button>
          </ToolbarActions>
        </Toolbar>
      </Container>

      <Container>
        {loading ? (
          <div>Lade Daten…</div>
        ) : offers.length === 0 ? (
          <NoOffersContent onAddNewOffer={openModal} />
        ) : (
          <OffersContent offers={offers} loading={loading} on_delete={handleConfirmDeleteOffer} />
        )}
      </Container>

      {/* ✅ Modal is mounted once and controlled via state */}
      <OfferModal
        open={offerModalOpen}
        onClose={closeModal}
        mode="create"
        refreshOfferData={fetchOfferData}
      />
    </Fragment>
  );
};

export { OffersPage };
